// location/subscription.service.js
import { apiService } from "../../app.service";

export const subscriptionApi = apiService.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ Send Reset Password Email
    sendResetPasswordEmail: builder.mutation({
      query: (data) => ({
        url: "/auth/forgot-password",
        method: "POST",
        body: data,
      }),
    }),

    // ✅ Cancel Subscription
    cancelSubscription: builder.mutation({
      query: () => ({
        url: "/subscription/cancel",
        method: "POST",
      }),
    }),

    // ✅ Get Pricing/Subscription Info
    getPricing: builder.query({
      query: () => ({
        url: "/payment/pricing",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useSendResetPasswordEmailMutation,
  useCancelSubscriptionMutation,
  useGetPricingQuery,
} = subscriptionApi;